<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import OrdersListItem from '@/components/mobile/telegram/order_components/OrdersListItem.vue';
import Order from "@/models/order";
import Point from '@/models/point';
import { getOrdersByPoint } from '@/composables/orderWorkerk'; 
import { getAllPoints } from '@/composables/itemWorker';
import { setBackButton, hideBackButton } from '@/tools/setTelegramButtons';
import SelectPoint from '@/components/mobile/telegram//selected_point_components/SelectPoint.vue';
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';

const defaultOrder: Order = {
  point: 1,
  id: 1,
  status: 'Новый',
  date_create: '',
  products: [
    {
      quantity: 1,
      product: {
        id: 1,
        quantity: 1,
        description: "",
        icon: "",
        name: "",
        packaging: {
          count: 1,
          id: '',
          name: ''
        },
      }
    },
  ],
  comment: 'Comment',
};

const orders = ref<Order[]>([defaultOrder, defaultOrder, defaultOrder]); 
const points = ref<Point[]>([]);
const selectedPoint = ref<Point | null>(null);
const ordersIsResieved = ref<boolean>(false)

async function getOrderByPoint(point_id: number) {
  ordersIsResieved.value = false;
  orders.value = await getOrdersByPoint(point_id);
  ordersIsResieved.value = true;
}

async function getPoints() {
  points.value = await getAllPoints();
}

onMounted(async () => {
  setBackButton();
  await getPoints();
})

onUnmounted(() => {
  hideBackButton();
});

async function selectPoint(point: Point) {
  selectedPoint.value = point;
  choosePoint();
  await getOrderByPoint(point.id);
}

const openModalSelectPoint = ref<Boolean>(false)

function choosePoint() {
  openModalSelectPoint.value = !openModalSelectPoint.value
}

</script>

<template>
  <Transition name="fade">
    <div class="background-blur-choose-point" v-if="openModalSelectPoint" @click="choosePoint()"></div>
  </Transition>
  <Transition name="slideUp">
    <SelectPoint v-if="openModalSelectPoint"
      :points="points"
      :selectedPoint="selectedPoint"
      @selectPoint="selectPoint"
      @closeModal="choosePoint()"
    />
  </Transition>
  <div class="admin-section">
    <div class="statistic-body">
      <p class="statistic-label">Статистика</p>
      <Transition name="fade">
        <div class="choose-point">
          <p class="selected-point__label">Выбранная точка</p>
          <p class="selected-point__name">{{ selectedPoint !== null ? selectedPoint.name : '---' }}</p>
          <AnimatePlaceHolder v-if="points.length === 0"
            width="100%"
            height="61px"
            border-radius="var(--border-radius-2)"
            style="margin-top: 10px;"
          />
          <button v-else
            type="button"
            class="point-btn btn"
            @click="choosePoint()"
          >
          {{ selectedPoint !== null ? 'Изменить точку' : 'Выбрать точку' }}
          <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.67578 12.1982C1.67578 12.1982 7.1886 7.05294 7.1886 6.68542C7.1886 6.3179 1.67578 1.1726 1.67578 1.1726" stroke="black" stroke-width="2.20513" stroke-linecap="round"/>
          </svg>
          </button>
        </div>
      </Transition>
      <Transition name="fade">
        <div class="orders-list" v-if="selectedPoint && orders.length > 0">
          <OrdersListItem
            v-for="(order, index) in orders"
            :key="order.id"
            :order="order"
            :isFirst="index === 0"
            :isLast="index === orders.length - 1"
            :isHistory="false"
            :point="selectedPoint"
            :isAdmin="true"
            :ordersIsResieved="ordersIsResieved"
          />
        </div>
      </Transition>
      <Transition name="fade">
        <p v-if="selectedPoint && orders.length === 0 && ordersIsResieved === true" class="no-orders">На этой точке ещё нет заказов</p>
      </Transition>
    </div>
  </div>
</template>

<style scoped>


.point-btn:active {
  transform: var(--transform-scale-active);
}

.btn {
  transition: all .3s ease;
}

.point-btn {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  background: none;
  font-family: inherit;
  -webkit-tap-highlight-color: transparent;
  font-size: 18px;
  width: 100%;
  background-color: #FFF1CC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: start;
  box-sizing: border-box;
  padding: 20px;
  border-radius: var(--border-radius-2);
  margin-top: 10px;
  color: black;
}

.selected-point__label {
  font-size: 16px;
  color: #989793;
}

.selected-point__name {
  font-size: 20px;
  font-weight: 500;
  margin-top: 5px;
}

.choose-point {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  padding: 20px;
  background-color: white;
  border-radius: var(--border-radius);
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
  margin-top: 30px;
}

.background-blur-choose-point {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  background-color: #8E8E9290;
  backdrop-filter: blur(10px);
}

.no-orders {
  font-size: 16px;
  margin-top: 20px;
}

.head-bnt-first-line {
  font-size: 18px;
  font-weight: 600;
  color: black;
  margin-top: 20px;
  width: 100%;
  text-align: start;
}

.orders-by-point{
  width: 100%;
}

.orders-list{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  gap: 10px;
  width: 100%;
  margin-bottom: 50px;
}

.statistic-body{
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
}

.add-admin-text{
  font-size: 16px;
  font-weight: 400;
}

.add-admin-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--grey-color);
  padding: 13px 21px;
  gap: 10px;
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}

.admins-body{
  width: 100%;
}

.label-section{
  font-size: 18px;
  font-weight: 500;
  text-align: start;
}

.admin-section{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.statistic-label {
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
}

</style>
